<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Conteos de Inventario</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="row justify-content-sm-end"></div>
              <div class="form-inline justify-content-sm-end">
                <input type="date" v-model="filter.fecha" class="form-control form-control-sm" @change="refreshConteo()"
                  style="width: 150px" />
                <input class="form-control form-control-sm rounded bright" placeholder="Filtrar Numero"
                  v-model="filter.searchtext" type="text" v-on:keyup.enter="refreshConteo()" />
                <select class="form-control form-control-sm rounded bright" v-model="filter.estado"
                  @change="refreshConteo()" style="width: 150px">
                  <option value>Todos</option>
                  <option value="1">Abierto</option>
                  <option value="2">Finalizado</option>
                  <option value="3">Anulado</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="refreshConteo()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fas fa-undo"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConteoInventarioTableComponent :dataTabla="dataTabla" />
    </div>
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="refreshConteo" />
    <div class="modal fade" id="conteoInventarioModal" tabindex="-1" role="dialog"
      aria-labelledby="conteoInventarioModal" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Nuevo Conteo
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent :current="current" />
              </div>
            </div>
            <br>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Tipo Conteo</label>
              <select class="form-control" id="exampleFormControlSelect1" v-model="filter.tipo">
                <option value="N">Normal</option>
                <option value="B">Conteo ABC</option>
                <option value="P">Próximos a Vencer</option>
                <option value="R">Revisión 80/20</option>
              </select>
            </div>
            <div class="modal-footer">
              <button type="button" @click="crearConteo" class="btn btn-success btn-block">
                Crear Conteo <i class="fas fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalTiendaSelect" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Elije una tienda
            </h5>
          </div>
          <div class="modal-body">
            <select class="form-control col-12" v-model="filter.tienda" @change="refreshConteo()">
              <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clearFilterData()">
              Cerrar
              <small>(Se mostraran todas las tiendas)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="floated-chat-btn" @click="abrirModalCrear">
      <i class="fas fa-clipboard-check"></i>&nbsp;Nuevo Conteo
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ConteoInventarioTableComponent from "@/components/inventario/conteo_inventario/ConteoInventarioTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";

export default {
  components: {
    ConteoInventarioTableComponent,
    TiendaSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        proveedor: "",
        fecha: "",
        tipo: "",
      },
      conteo: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      posiciones: [],
      current: {},
      filtro_tienda: "",
      dataTabla: "",
      filtro_producto: "",
      _filtro_producto: "",
      producto: "",
      errors: {
        producto: "",
      },
      barra: "",
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.refreshConteo();
    $("#modalTiendaSelect").modal("show");
  },
  methods: {
    refreshConteo(page) {
      let fecha;
      if (this.filter.fecha) {
        fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("inv", "conteo-inventario", {
        page: this.currentPage,
        "filter[search]": this.filter.searchtext,
        fecha: fecha,
        tienda: this.filter.tienda,
        estado: this.filter.estado,
        numero: this.filter.numero,
        tipo: this.filter.tipo,
      }).then((response) => {
        this.dataTabla = response.data;
      });
      $("#modalTiendaSelect").modal("hide");
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.fecha = "";
      DynamicService.fetch("inv", "conteo-inventario", {
        page: 1,
      }).then((response) => {
        this.dataTabla = response.data;
      });
      $("#modalTiendaSelect").modal("show");
    },
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    abrirModalCrear() {
      // Reutiliza la tienda elegida en el modal inicial para no pedirla dos veces
      if (this.filter.tienda) {
        this.$set(this.current, "tienda", this.filter.tienda);
      }
      $("#conteoInventarioModal").modal("show");
    },
    crearConteo() {
      DynamicService.save("inv", "conteo-inventario", {
        tienda: this.current.tienda,
        tipo: this.filter.tipo,
      }).then((response) => {
        this.refreshConteo();
        $("#conteoInventarioModal").modal("hide");
        this.$router.push({
          name: "inventario-conteo-editar",
          params: {
            id: response.data.id,
          },
        });
      });
    },
  },
};
</script>